/* unplugin-vue-components disabled */import { ElLoadingDirective as __unplugin_directives_0 } from 'element-plus/es';import 'element-plus/es/components/loading/style/css';
import { ElDivider as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/divider/style/css';
import { ElInput as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f5530af0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "channel-wrapper"
};
const _hoisted_2 = {
  class: "left"
};
const _hoisted_3 = {
  class: "top-bar"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "全部渠道", -1));
const _hoisted_5 = {
  class: "content"
};
const _hoisted_6 = {
  class: "content-title"
};
const _hoisted_7 = {
  class: "title"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  key: 0,
  class: "channel-list"
};
const _hoisted_10 = {
  class: "channel-list"
};
const _hoisted_11 = {
  class: "channel-list"
};
const _hoisted_12 = {
  class: "right"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top-bar"
}, "所选渠道", -1));
const _hoisted_14 = {
  class: "content"
};
const _hoisted_15 = {
  class: "flex-between"
};
const _hoisted_16 = ["onClick"];
import { apiUsdkCfgAddChannel, apiUsdkCfgGetAddList } from '@/api/usdk';
import ChannelCheck from './channelCheck.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    gid: {
      type: Number,
      default: 0
    },
    area: {
      type: Number,
      default: 0 // 0 不限， 1 国内， 2 海外
    }
  },
  setup(__props) {
    const props = __props;
    const state = reactive({
      allChannel: [],
      selectedIds: [],
      loading: false,
      count: 0,
      status: false,
      filterName: '',
      channelCategories: [{
        title: '官方国内渠道',
        checkAll: false,
        channel: [],
        type: 1
      }, {
        title: '官方海外渠道',
        checkAll: false,
        channel: [],
        type: 4
      }, {
        title: '三方渠道',
        checkAll: false,
        channel: [],
        type: 0
      }
      // {
      //   title: '更多渠道',
      //   checkAll: false,
      //   channel: [],
      //   type: 100
      // }
      ],
      isCheckAll: false,
      selectedChannel: {},
      showMore: false,
      confirmLoading: false
    });
    const getChannelList = () => {
      state.loading = true;
      apiUsdkCfgGetAddList({
        gid: props.gid
      }).then(({
        data
      }) => {
        state.allChannel = data.filter(item => !item.status && item.level !== 'D');
      }).finally(() => {
        state.loading = false;
      });
    };
    watch(() => props.gid, val => {
      if (val) {
        getChannelList();
      }
    }, {
      immediate: true
    });
    // 全选/取消全选
    const handleSelectAll = (type, index) => {
      let isCheckAll = index > -1 ? state.channelCategories[index].checkAll : state.isCheckAll;
      state.allChannel.filter(item => type > -1 ? item.type === type && item.level !== 'D' : item).forEach(channel => {
        let i = state.selectedIds.indexOf(channel.id);
        if (isCheckAll) {
          state.selectedIds.splice(i, 1);
          delete state.selectedChannel[channel.id];
        } else if (!state.selectedIds.includes(channel.id)) {
          state.selectedIds.push(channel.id);
          state.selectedChannel[channel.id] = channel;
        }
      });
      if (type === -1) {
        state.isCheckAll = !isCheckAll;
        state.channelCategories.forEach(item => {
          item.checkAll = !isCheckAll;
        });
      } else {
        if (isCheckAll) state.isCheckAll = false;
        state.channelCategories[index].checkAll = !isCheckAll;
      }
    };
    const onChange = channel => {
      let i = state.selectedIds.indexOf(channel.id);
      if (i > -1) {
        state.selectedIds.splice(i, 1);
        delete state.selectedChannel[channel.id];
      } else {
        state.selectedIds.push(channel.id);
        state.selectedChannel[channel.id] = channel;
      }
    };
    const handleSubmit = () => {
      if (state.selectedIds.length <= 0) {
        ElMessage.warning('还未选择渠道');
        return;
      }
      state.confirmLoading = true;
      let params = {
        gid: props.gid,
        edit: 1,
        channelIds: state.selectedIds.join(',')
      };
      apiUsdkCfgAddChannel(params).then(res => {
        if (res.code === 0) {
          getChannelList();
          state.selectedIds = [];
          state.selectedChannel = {};
        }
      }).finally(() => {
        state.confirmLoading = false;
      });
    };
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_el_input = __unplugin_components_1;
      const _component_el_divider = __unplugin_components_2;
      const _directive_loading = __unplugin_directives_0;
      return _openBlock(), _createElementBlock(_Fragment, null, [(_openBlock(), _createBlock(_Teleport, {
        to: "#addChannel"
      }, [_createVNode(_component_el_button, {
        loading: _unref(state).confirmLoading,
        type: "primary",
        onClick: handleSubmit
      }, {
        default: _withCtx(() => [_createTextVNode("添加渠道")]),
        _: 1
      }, 8, ["loading"])])), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("span", {
        class: "link cp",
        onClick: _cache[0] || (_cache[0] = $event => handleSelectAll(-1))
      }, _toDisplayString(_unref(state).isCheckAll ? '取消全选' : '全选'), 1)]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_input, {
        modelValue: _unref(state).filterName,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(state).filterName = $event),
        placeholder: "请输入渠道名搜索"
      }, null, 8, ["modelValue"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).channelCategories, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: item.type
        }, [_unref(state).allChannel.filter(c => c.type === item.type && c.level !== 'D').length ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(item.title), 1), _createElementVNode("div", {
          class: "link cp",
          onClick: $event => handleSelectAll(item.type, index)
        }, _toDisplayString(item.checkAll ? '取消全选' : '全选'), 9, _hoisted_8)]), item.type !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).allChannel.filter(c => c.type === item.type && c.level !== 'D' && c.name.toLocaleLowerCase().includes(_unref(state).filterName.toLocaleLowerCase())), c => {
          return _openBlock(), _createBlock(ChannelCheck, {
            key: c.id,
            channel: c,
            selectedIds: _unref(state).selectedIds,
            onChange: onChange
          }, null, 8, ["channel", "selectedIds"]);
        }), 128))])) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).allChannel.filter(c => c.type === item.type && c.level !== 'D' && c.imp === 1 && c.name.toLocaleLowerCase().includes(_unref(state).filterName.toLocaleLowerCase())), c => {
          return _openBlock(), _createBlock(ChannelCheck, {
            key: c.id,
            channel: c,
            selectedIds: _unref(state).selectedIds,
            onChange: onChange
          }, null, 8, ["channel", "selectedIds"]);
        }), 128))]), _createElementVNode("div", {
          onClick: _cache[2] || (_cache[2] = $event => _unref(state).showMore = !_unref(state).showMore),
          style: {
            "cursor": "pointer"
          }
        }, [_createVNode(_component_el_divider, {
          plain: ""
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(state).showMore ? '收起' : '展开') + "更多", 1)]),
          _: 1
        })]), _withDirectives(_createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).allChannel.filter(c => c.type === item.type && c.level !== 'D' && c.imp === 0 && c.name.toLocaleLowerCase().includes(_unref(state).filterName.toLocaleLowerCase())), c => {
          return _openBlock(), _createBlock(ChannelCheck, {
            key: c.id,
            channel: c,
            selectedIds: _unref(state).selectedIds,
            onChange: onChange
          }, null, 8, ["channel", "selectedIds"]);
        }), 128))], 512), [[_vShow, _unref(state).showMore]])], 64))], 64)) : _createCommentVNode("", true)]);
      }), 128))])), [[_directive_loading, _unref(state).loading]])]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).selectedChannel, (channel, key) => {
        return _openBlock(), _createElementBlock("div", {
          class: "marginB10",
          key: key
        }, [_createElementVNode("div", _hoisted_15, [_createElementVNode("span", null, _toDisplayString(channel.name), 1), _createTextVNode(), _createElementVNode("span", {
          class: "link cp del",
          onClick: $event => onChange(channel)
        }, "移除", 8, _hoisted_16)])]);
      }), 128))])])])], 64);
    };
  }
});